import LinkForPopupPropTypes from "../../LinkForPopupPropTypes";
import PropTypes from "prop-types";
import React from "react";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

const LinkForPopup = (props) => {
  return (
    <a className="inline_link area" onClick={props.onClickPopupLink}>
      <input
        type="text"
        name="input_area_name"
        className="area no_icon"
        placeholder="地域を選択"
        readOnly="readonly"
        value={props.inputValue}
        onChange={props.onChangeInputValue}
      />
    </a>
  );
};

LinkForPopup.propTypes = LinkForPopupPropTypes;

export default LinkForPopup;